import { Icon, Text, View } from "../../Components";
import { Metrics, Helpers, Colors, sensorLive, Spacing } from "../../global";
import { Menu, ConfigProvider } from "antd";
import { ReactComponent as optionsIcon } from "../../Assets/SVG/Options.svg";
import { React } from "react";
import { ReactComponent as usbIcon } from "../../Assets/SVG/USBPowered.svg";
import { ReactComponent as battery100Icon } from "../../Assets/SVG/Battery100.svg";
import { ReactComponent as battery80Icon } from "../../Assets/SVG/Battery80.svg";
import { ReactComponent as battery60Icon } from "../../Assets/SVG/Battery60.svg";
import { ReactComponent as battery40Icon } from "../../Assets/SVG/Battery40.svg";
import { ReactComponent as battery20Icon } from "../../Assets/SVG/Battery20.svg";
import { ReactComponent as battery10Icon } from "../../Assets/SVG/Battery10.svg";
import { ReactComponent as batteryLowIcon } from "../../Assets/SVG/BatteryLow.svg";
import { ReactComponent as sthpIcon } from "../../Assets/SVG/SthpLogo.svg";

const styles = {
  symbolContainer: {
    display: "inherit",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    paddingRight: 15,
  },
};

 function celsiusToFahrenheit(celsius) {
   return (celsius * 1.8 + 32).toFixed(2);
 }

const sensorColumns = (navigate, allSites, currentStore) => [
  
  {
    sorter: (a, b) => {
      var usbPowered =
        currentStore[a]?.toolSystem?.sysPowerState == "USB" ? true : false;

      if (usbPowered) {
        return 1;
      } else {
        return (
          currentStore[a]?.toolSystem?.sysBatteryLvl -
          currentStore[b]?.toolSystem?.sysBatteryLvl
        );
      }
    },
    align: "center",
    width: 30,
    render: (_, a) => {
      var usbPowered =
        currentStore[a]?.toolSystem?.sysPowerState == "USB" ? true : false;
      var batteryLvl = currentStore[a]?.toolSystem?.sysBatteryLvl;

      return (
        <View style={{ ...styles.symbolContainer, width: "200px" }}>
          {usbPowered == undefined ? (
            <></>
          ) : usbPowered ? (
            <Icon
              size="xs"
              color={Colors.lightGrey}
              svg={usbIcon}
              style={{ backgroundColor: "transparent !important" }}
            />
          ) : (
            <Icon
              svg={
                batteryLvl == 100
                  ? battery100Icon
                  : batteryLvl >= 80
                  ? battery80Icon
                  : batteryLvl >= 60
                  ? battery60Icon
                  : batteryLvl >= 40
                  ? battery40Icon
                  : batteryLvl >= 20
                  ? battery20Icon
                  : batteryLvl >= 10
                  ? battery10Icon
                  : batteryLowIcon
              }
              size="xs"
            />
          )}
        </View>
      );
    },
    onCell: (record, rowIndex) => {
      return {
        style: {
          backgroundColor: Colors.transparent,
        },
      };
    },
  },

  ,
  {
    title: "Connection",
    sorter: (a, b) => "Online".localeCompare("Online"),
    align: "center",
    render: (_, a) => {
      var color = "greenDark"; //'main';
      var connectionMsg = "Online";

      if (sensorLive.isLive(currentStore[a]?.sensor?.updatedAt) === false) {
        color = "redDark";
        connectionMsg =
          "Offline\n\r (" +
          sensorLive.getTimeElapsedString(currentStore[a]?.sensor?.updatedAt) +
          ")";
      }

      return (
        <Text as="md" weight="medium" color={color}>
          {connectionMsg}
        </Text>
      );
    },
    onCell: (record, rowIndex) => {
      var backgroundColor = Colors.successLight;

      if (
        sensorLive.isLive(currentStore[record]?.sensor?.updatedAt) === false
      ) {
        backgroundColor = Colors.errorLight;
      }

      return {
        style: {
          backgroundColor: backgroundColor,
        },
      };
    },
  },
  {
    title: "Alarm",
    sorter: (a, b) => {
      console.log("a", a);
      console.log("b", b);
      let alertsA = currentStore?.[a]?.alerts;
      let hasAlertA =
        alertsA != null && Array.isArray(alertsA) && alertsA.length > 0;
      let alertLengthA = 0;
      if (hasAlertA) {
        alertLengthA = 0;
        alertsA.forEach((alert) => {
          alertLengthA += alert.alertState.alertCnt;
        });
      }

      let alertsB = currentStore?.[b]?.alerts;
      let hasAlertB =
        alertsB != null && Array.isArray(alertsB) && alertsB.length > 0;
      let alertLengthB = 0;
      if (hasAlertB) {
        alertLengthB = 0;
        alertsB.forEach((alert) => {
          alertLengthB += alert.alertState.alertCnt;
        });
      }

      return alertLengthA - alertLengthB;
    },
    align: "center",
    render: (_, a) => {
      let color = "redDark"; //'main';

      let alerts = currentStore?.[a]?.alerts;
      let hasAlert =
        alerts != null && Array.isArray(alerts) && alerts.length > 0;
      let alertLength = 0;
      if (hasAlert) {
        alertLength = 0;
        alerts.forEach((alert) => {
          alertLength += alert.alertState.alertCnt;
        });
      }

      return alertLength > 0 ? (
        <Text as="md" weight="medium" color={color}>
          Alarm
        </Text>
      ) : (
        <View style={Helpers.textCenter}></View>
      );
    },
    onCell: (record, rowIndex) => {
      var backgroundColor = Colors.transparent; //Colors.blueLightest;

      let alerts = currentStore?.[record]?.alerts;
      let hasAlert =
        alerts != null && Array.isArray(alerts) && alerts.length > 0;
      let alertLength = 0;
      if (hasAlert) {
        alertLength = 0;
        alerts.forEach((alert) => {
          alertLength += alert.alertState.alertCnt;
        });
      }

      if (alertLength > 0) {
        backgroundColor = Colors.errorLight;

        return {
          style: {
            backgroundColor: backgroundColor,
          },
        };
      }
    },
  },
  // Since we currently only support the IntelliTemp device, we are explicitly defining this as the tool type
  // When more devices are supported, will need to adjust this to dynamically change the UI based on the tool type
  {
    title: "Type",
    sorter: (a, b) =>
      currentStore?.[a]?.toolType.localeCompare(currentStore?.[b]?.toolType),
    align: "center",
    render: (_, a) => {
      var toolType = currentStore?.[a]?.toolType;

      if (currentStore?.[a]?.toolType == "STHP") {
        toolType = "IntelliTemp";
      }

      return (
        <View
          style={{
            ...Helpers.rowCross,
            ...Metrics.smallVerticalPadding,
            ...Metrics.smallHorizontalPadding,
            flexWrap: "wrap",
          }}
        >
          <View style={{ ...styles.symbolContainer, paddingRight: 5 }}>
            <Icon size="xs" color={Colors.lightGrey} svg={sthpIcon} />
          </View>
          <View style={Helpers.textCenter}>
            <Text
              as="md"
              weight="regular"
              color={"textPrimary"}
              style={{ maxWidth: "100%" }}
            >
              IntelliTemp
            </Text>
          </View>
        </View>
      );
    },
  },
  {
    title: "Temperature",
    sorter: (a, b) =>
      currentStore[a]?.sensor?.sthp_temp -
      currentStore[b]?.sensor?.sthp_temp,
    align: "center",
    render: (_, a) => {
      return (
        <View style={Helpers.textCenter}>
          <Text as="md" weight="regular" color={"textPrimary"}>
            {allSites.user.settings.appearance.temperatureUnit === "°C"
              ? `${currentStore[a]?.sensor?.sthp_temp} °C`
              : `${celsiusToFahrenheit(currentStore[a]?.sensor?.sthp_temp)} °F`}
            
          </Text>
        </View>
      );
    },
  },
  {
    title: "Humidity",

    sorter: (a, b) => {
      const humidA = currentStore?.[a]?.sensor?.sthp_humid;
      const humidB = currentStore?.[b]?.sensor?.sthp_humid;

      if (typeof humidA === "number" && typeof humidB === "number") {
        return humidA - humidB;
      } else if (typeof humidA === "number") {
        return -1;
      } else if (typeof humidB === "number") {
        return 1;
      } else {
        return 0;
      }
    },
    align: "center",
    render: (_, a) => {
      var humid;

      if (currentStore?.[a]?.settings?.channels?.sthp_humid?.enabled === true) {
        humid =
          currentStore?.[a]?.sensor?.sthp_humid.toFixed(2) +
          " " +
          currentStore?.[a]?.settings?.channels?.sthp_humid?.unit;
      } else {
        humid = null;
      }

      return (
        <View style={Helpers.textCenter}>
          <Text as="md" weight="regular" color={"textPrimary"}>
            {humid}
          </Text>
        </View>
      );
    },
  },
  {
    title: "Name",
    sorter: (a, b) =>
      currentStore?.[a]?.settings?.toolName.localeCompare(
        currentStore?.[b]?.settings?.toolName
      ),
    align: "center",
    render: (_, a) => {
      return (
        <View style={Helpers.textCenter}>
          <Text as="md" weight="regular" color={"textPrimary"}>
            {currentStore?.[a]?.settings?.toolName}
          </Text>
        </View>
      );
    },
  },
  {
    title: "Location",
    sorter: (a, b) =>
      currentStore?.[a]?.settings?.toolLocation.localeCompare(
        currentStore?.[b]?.settings?.toolLocation
      ),
    align: "center",
    render: (_, a) => {
      return (
        <View style={Helpers.textCenter}>
          <Text as="md" weight="regular" color={"textPrimary"}>
            {currentStore?.[a]?.settings?.toolLocation}
          </Text>
        </View>
      );
    },
  },
  {
    title: "Sensor Serial No.",
    sorter: (a, b) => a.localeCompare(b),
    align: "center",
    render: (_, a) => {
      return (
        <View style={Helpers.textCenter}>
          <Text as="md" weight="regular" color={"textPrimary"}>
            {a}
          </Text>
        </View>
      );
    },
  },
  {
    title: "Action",
    align: "center",
    render: (_, a) => {
      function getItem(label, key, icon, children, theme) {
        return {
          key,
          icon,
          children,
          label,
          theme,
        };
      }
      const items = [
        getItem(
          "",
          "sub2",
          <Icon color={Colors.textSecondary} svg={optionsIcon} size="sm" />,
          [getItem("Details", "1")],
          "light"
        ),
      ];
      return (
        <View style={{ ...Helpers.center }}>
          <ConfigProvider
            theme={{
              components: {
                Menu: {
                  iconMarginInlineEnd: 0,
                  iconSize: 0,
                  collapsedIconSize: 0,
                  itemActiveBg: Colors.transparent,
                  // itemHoverBg: Colors.transparent,
                  popupBg: Colors.lineDivider,
                },
              },
            }}
          >
            <Menu
              style={{
                border: "none",
                margin: 0,
                padding: 0,
                backgroundColor: Colors.transparent,
                paddingLeft: 20,
              }}
              defaultSelectedKeys={[]}
              selectedKeys={[]}
              defaultOpenKeys={[]}
              mode={"vertical"}
              theme={"light"}
              items={items}
              expandIcon={<></>}
              onClick={({ key }) => {
                if (key === "1") {
                  navigate(`/sensor/${a}`, {
                    state: { lastStore: currentStore },
                  });
                }
              }}
            />
          </ConfigProvider>
        </View>
      );
    },
  },
];

// Usage:
// const sensorColumns = SensorColumns()
export default sensorColumns;